import React, { useState } from 'react'
import { IoCloseOutline, IoMenuOutline } from 'react-icons/io5';
import { NavLink } from 'react-router-dom';
import logo from '../images/delightslogo.jpeg';

const Navbar = () => {
  const [isNavActive, setIsNavActive] = useState(false);

  const toggleNav = () => {
    setIsNavActive(!isNavActive);
  };

  const innactivateNav = () => {
    setIsNavActive(false);
  }

  return (
    <div class='navbar'>
        <div class='logo-container'>
            <div>
              <img src={logo} alt='Logo' className='nav-logo'/>
            </div>
            <div>
              <p className='brand-name'>Decor Delights</p>
            </div>
        </div>
        
        <ul class={`nav-links ${isNavActive ? 'active' : ''}`}>
            <NavLink to='/' onClick={()=>innactivateNav()} style={{textDecoration: 'none'}}>
              <li>Home</li>
            </NavLink>
            <div class='separator'></div>
            <NavLink to='/about' onClick={()=>innactivateNav()} style={{textDecoration: 'none'}}>
              <li>About Us</li>
            </NavLink>
            <div class='separator'></div>
            <NavLink to='/services' onClick={()=>innactivateNav()} style={{textDecoration: 'none'}}>
              <li>Services</li>
            </NavLink>
            <div class='separator'></div>
            <NavLink to='/video-gallery' onClick={()=>innactivateNav()} style={{textDecoration: 'none'}}>
              <li>Video Gallery</li>
            </NavLink>
            <div class='separator'></div>
            <NavLink to='/testimonials' onClick={()=>innactivateNav()} style={{textDecoration: 'none'}}>
              <li>Testimonials</li>
            </NavLink>
            <div class='separator'></div>
            <NavLink to='/contact' onClick={()=>innactivateNav()} style={{textDecoration: 'none'}}>
              <li>Contact</li>
            </NavLink>
        </ul>

        <div onClick={toggleNav} class='menu'>
            {isNavActive ? <IoCloseOutline size={40} color='rgb(42, 83, 106)'/> : <IoMenuOutline size={40} color='rgb(42, 83, 106)'/>}
        </div>
    </div>
  )
}

export default Navbar